import React from 'react'


const AdditionalLinks = () => {
return (
      <div class="additional_links_div">
        <div>
          <h3 class="text-center">
            SCHEDULE
          </h3>
          <br />
          <br />
          <p className="text-center">6/3  |  WWN Podcast Ep. 2.4  |  PNW Combine</p>
          <br />
          <br />
          <p className="text-center">Starting June 2025 | Preseason Rankings Preview</p>
          <br />
          <br />
          <p className="text-center"></p>
        </div>
      </div>
  )
}
export default AdditionalLinks
